
  /* The PROMISE, not the loader:done event. Under prefers-reduced-motion the
     timeline resolves during parse, so a listener registered after the loader
     script would miss the event entirely. The promise cannot be missed. */
  window.RFKLoader.whenDone.then(function () {
    var el = document.getElementById('rfkl-loader');
    if (el) el.remove();
  });
